import * as React from 'react';

import {Button} from '../../../button/button';

import styles from './show-hide-button.module.css';

type Props = {
    icon: React.ReactNode;
    buttonText: string;
    onClick: () => void;
    getButtonRef?: () => any;
};

export function ShowHideButton(props: Props) {
    const {icon, buttonText, onClick, getButtonRef} = props;

    return (
        <Button variant='text-secondary' size='small' onClick={onClick} getButtonRef={getButtonRef}>
            <div className={styles['button-content']}>
                <div className={styles.icon}>{icon}</div>
                {buttonText}
            </div>
        </Button>
    );
}
